import {NgModule} from '@angular/core'
import {ProDirectoryComponent} from './pro-directory.component'
import {ProDirectoryCardComponent} from './pro-directory-card/pro-directory-card.component'
import {CommonModule, NgOptimizedImage} from '@angular/common'
import {FontAwesomeModule} from '@fortawesome/angular-fontawesome'
import {TranslocoModule} from '@ngneat/transloco'
import {RouterModule} from '@angular/router'
import {BrandingModule} from '../branding/branding.module'
import {RemoveAgencyPrefixPipe} from '../../pipes/remove-agency-prefix.pipe'
import {ChipComponent} from '../../../craft/chip/chip.component'
import {DropdownModule} from '../../../craft/dropdown/dropdown.module'
import {PipesModule} from '../../pipes/pipes.module'
import {GoogleRatingComponent} from '../../../craft/google-rating/google-rating.component'
import {AverageGooglePlacePipe} from '../../pipes/average-google-place.pipe'
import {AdditionalLocationsPipe} from '../../pipes/additional-locations.pipe'
import {DefaultLocationPipe} from '../../pipes/default-location.pipe'
import {ButtonModule} from '../../../craft/button/button.module'
import {CardsModule} from '../../../craft/cards/cards.module'
import {FilterModule} from '../../../craft/filter/filter.module'
import {MessageModule} from '../../../craft/message/message.module'
import {OpenContactModalOnClickDirective} from '../../directives/open-contact-modal/open-contact-modal.directive'
import {SortingModule} from '../../../craft/sorting/sorting.module'
import {ProDirectoryCardMetricsComponent} from './pro-directory-card/pro-directory-card-metrics.component'
import {ProTopPartnerBannerComponent} from '../pro-top-partner-banner/pro-top-partner-banner.component'
import {MaxPipe} from '../../pipes/max.pipe'
import {GalleryComponent} from '../gallery/gallery.component'
import {ProMapComponent} from '../pro-map/pro-map.component'
import {FullLocationPipe} from '../../pipes/full-location.pipe'

@NgModule({
  declarations: [ProDirectoryComponent, ProDirectoryCardComponent, ProDirectoryCardMetricsComponent],
  imports: [
    CommonModule,
    FontAwesomeModule,
    TranslocoModule,
    RouterModule,
    BrandingModule,
    NgOptimizedImage,
    RemoveAgencyPrefixPipe,
    ChipComponent,
    DropdownModule,
    PipesModule,
    GoogleRatingComponent,
    AverageGooglePlacePipe,
    AdditionalLocationsPipe,
    DefaultLocationPipe,
    ButtonModule,
    CardsModule,
    FilterModule,
    MessageModule,
    OpenContactModalOnClickDirective,
    SortingModule,
    GalleryComponent,
    MaxPipe,
    ProMapComponent,
    FullLocationPipe,
    ProTopPartnerBannerComponent,
  ],
  exports: [ProDirectoryComponent, ProDirectoryCardComponent],
})
export class ProDirectoryModule {}
